import { render, staticRenderFns } from "./DynamicFileSelector.vue?vue&type=template&id=37cb7fb7&"
import script from "./DynamicFileSelector.vue?vue&type=script&lang=js&"
export * from "./DynamicFileSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37cb7fb7')) {
      api.createRecord('37cb7fb7', component.options)
    } else {
      api.reload('37cb7fb7', component.options)
    }
    module.hot.accept("./DynamicFileSelector.vue?vue&type=template&id=37cb7fb7&", function () {
      api.rerender('37cb7fb7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/components/dynamic-file-selector/DynamicFileSelector.vue"
export default component.exports